(function () {
  function initEditorialPressQuotes(section) {
    if (!section || section.dataset.pressQuotesInit === 'true') return;

    var tabs = Array.from(section.querySelectorAll('[data-press-quote-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-press-quote-panel]'));
    var sliderElement = section.querySelector('[data-editorial-press-quotes-slider]');
    if (!tabs.length || !panels.length) return;

    section.dataset.pressQuotesInit = 'true';

    var initialIndex = tabs.findIndex(function (tab) {
      return tab.classList.contains('is-active');
    });
    if (initialIndex < 0) initialIndex = 0;

    var swiper = null;
    var sectionStyles = window.getComputedStyle(section);
    var mobileLogoGap = parseFloat(sectionStyles.getPropertyValue('--editorial-press-quotes-mobile-logo-gap')) || 12;
    var desktopLogoGap = parseFloat(sectionStyles.getPropertyValue('--editorial-press-quotes-desktop-logo-gap')) || 40;

    if (sliderElement && typeof window.Swiper === 'function') {
      swiper = new window.Swiper(sliderElement, {
        slidesPerView: 'auto',
        spaceBetween: mobileLogoGap,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        initialSlide: initialIndex,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        a11y: false,
        breakpoints: {
          750: {
            spaceBetween: desktopLogoGap
          }
        }
      });
    }

    section.pressQuotesSwiper = swiper;

    function activateQuote(index, moveFocus, syncSlider) {
      if (index < 0 || index >= tabs.length) return;

      var quoteId = tabs[index].getAttribute('data-press-quote-tab');

      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-press-quote-panel') === quoteId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (moveFocus) tabs[index].focus();
      if (syncSlider && swiper && swiper.activeIndex !== index) swiper.slideTo(index);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateQuote(index, false, true);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        activateQuote(nextIndex, true, true);
      });
    });

    if (swiper) {
      swiper.on('slideChange', function () {
        activateQuote(swiper.activeIndex, false, false);
      });
    }

    activateQuote(initialIndex, false, false);
  }

  function initAllEditorialPressQuotes() {
    document.querySelectorAll('[data-editorial-press-quotes]').forEach(initEditorialPressQuotes);
  }

  document.addEventListener('DOMContentLoaded', initAllEditorialPressQuotes);
  document.addEventListener('shopify:section:load', function (event) {
    initEditorialPressQuotes(event.target.querySelector('[data-editorial-press-quotes]'));
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-editorial-press-quotes]');
    if (section && section.pressQuotesSwiper) section.pressQuotesSwiper.destroy(true, true);
  });
})();
